import { actions, types } from './requests'
export const GETCATEGORY_TYPES = {
    ...types('GETCATEGORY'),
}
export const GETCATEGORY_ACTIONS = {
    ...actions('GETCATEGORY'),
}
